import { useRef } from 'react'
import { AnimatePresence, motion } from 'framer-motion'
import { XamaLogo } from '../../assets/svgs/icons'
import styles from './styles.module.css'


const UpgradeIcon = () => (
  <svg
    width="40"
    height="41"
    viewBox="0 0 40 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <rect width="40" height="41" rx="10" fill="#F1D3FF" fillOpacity="0.5" />
    <path
      d="M11.3645 32.8C11.1081 33.0667 10.7664 33.0667 10.5527 32.8C10.2964 32.5778 10.2964 32.1778 10.5527 31.9556L14.0561 28.3111C14.2697 28.0889 14.6542 28.0889 14.8678 28.3111C15.0814 28.5333 15.0814 28.9333 14.8678 29.1556L11.3645 32.8ZM31.1455 8.88889C30.5474 8.31111 29.7784 8 29.0521 8C28.283 8 27.514 8.31111 26.9586 8.88889L23.3271 12.6667L14.4406 9.55556C14.3551 9.51111 14.227 9.51111 14.1415 9.51111C14.0561 9.55556 13.9279 9.6 13.8425 9.68889L11.6208 12.0444C11.5781 12.0444 11.5781 12.0889 11.5354 12.0889C11.4499 12.2222 11.4499 12.3556 11.4499 12.4889C11.4499 12.6667 11.5354 12.8 11.6208 12.8889L11.7063 12.9333L18.4139 17.7778L16.2777 20L13.757 19.5111C13.6716 19.4667 13.5861 19.4667 13.4579 19.5111C13.3725 19.5556 13.287 19.6 13.2443 19.6444L10.98 22C10.9372 22.0444 10.8945 22.0889 10.8945 22.1333C10.8091 22.2667 10.8091 22.4 10.8518 22.5333C10.8518 22.6222 10.8945 22.7556 10.98 22.8444C11.0227 22.8889 11.1081 22.9333 11.1509 22.9778L15.466 25.2L17.6021 29.6889C17.6449 29.7333 17.6876 29.8222 17.7303 29.8667C17.8158 29.9556 17.9012 30 18.0294 30C18.1575 30.0444 18.2857 30 18.3712 29.9556C18.4566 29.9111 18.4993 29.9111 18.5421 29.8667L20.7637 27.5111C20.8491 27.4222 20.8919 27.3333 20.9346 27.2444C20.9346 27.1556 20.9773 27.0667 20.9346 26.9778L20.4219 24.3556L22.6008 22.1333L27.215 29.1111C27.2577 29.1556 27.2577 29.1556 27.3004 29.2C27.3858 29.2889 27.514 29.3778 27.6422 29.3778C27.8131 29.3778 27.9413 29.3333 28.0267 29.2889L28.1122 29.2L30.3765 26.8444C30.4619 26.8 30.5047 26.6667 30.5047 26.5778C30.5474 26.4444 30.5474 26.3556 30.5047 26.2222L27.514 17.0222L31.1455 13.2444C31.7009 12.6667 32 11.8667 32 11.0667C32 10.3111 31.7009 9.51111 31.1455 8.88889ZM13.1162 12.1778L14.4406 10.8L22.3872 13.6444L19.2256 16.8889L12.9453 12.3556L13.1162 12.1778ZM29.1802 26.3556L27.8131 27.8222L23.4125 21.2444L26.5741 18L29.2657 26.2667L29.1802 26.3556ZM30.2911 12.4L19.3965 23.7333C19.3111 23.8222 19.2684 23.9111 19.2684 24C19.2256 24.0889 19.2256 24.1778 19.2256 24.3111L19.7383 26.8889L18.2857 28.4L16.4059 24.4889C16.3632 24.4444 16.3632 24.3556 16.3204 24.3111C16.2777 24.2667 16.1923 24.2222 16.1495 24.2222L12.3899 22.2667L13.8425 20.7556L16.3204 21.2889C16.4486 21.2889 16.534 21.2889 16.6195 21.2444C16.7049 21.2444 16.7904 21.1556 16.8758 21.1111L27.7704 9.77778C28.1122 9.37778 28.5821 9.2 29.0521 9.2C29.4793 9.2 29.9493 9.37778 30.2911 9.77778C30.6328 10.1333 30.8465 10.6222 30.8465 11.0667C30.8465 11.5556 30.6328 12.0444 30.2911 12.4ZM8.97196 30.3556C8.75834 30.5778 8.37383 30.5778 8.16021 30.3556C7.9466 30.0889 7.9466 29.7333 8.16021 29.5111L11.6636 25.8222C11.9199 25.6 12.2617 25.6 12.4753 25.8222C12.7316 26.0444 12.7316 26.4444 12.4753 26.6667L8.97196 30.3556Z"
      fill="#9002CD"
    />
  </svg>
)

const PackagesIcon = () => (
  <svg
    width="41"
    height="39"
    viewBox="0 0 41 39"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <rect width="41" height="39" rx="10" fill="#F1D3FF" fillOpacity="0.5" />
    <path
      d="M8.52303 31C8.22799 31 8 30.7632 8 30.4869C8 24.8162 8 19.1456 8 13.4618C8 13.1855 8.22799 12.9619 8.52303 12.9619H13.3376L14.5982 8.38326C14.6653 8.10696 14.9469 7.94908 15.2286 8.01486L32.6227 12.5935C32.8909 12.6593 33.0519 12.9356 32.9848 13.2118C31.4828 18.6983 29.9941 24.1716 28.4921 29.658C28.425 29.9211 28.13 30.0922 27.8618 30.0132L27.0437 29.8027V30.4869C27.0437 30.7632 26.8023 31 26.5207 31H8.52303ZM13.7936 24.2242C13.8606 24.1452 13.9545 24.1058 14.0484 24.0795H14.0618H14.0752H14.0886H14.102H14.1154H14.1289H14.1423L14.1557 24.0663L14.1691 24.0795H14.1825H14.1959H14.2093H14.2227H14.2361H14.2496H14.263H14.2764C14.3703 24.1058 14.4507 24.1452 14.5312 24.2242L16.2344 25.8951L21.6793 20.5666C21.7463 20.4876 21.8402 20.4482 21.9341 20.4218H21.9475H21.9609H21.9743H21.9877H22.0011L22.0146 20.4087H22.028H22.0414H22.0548H22.0682H22.0816L22.095 20.4218H22.1084H22.1218H22.1353H22.1487H22.1621C22.256 20.4482 22.3364 20.4876 22.4169 20.5666L25.9976 24.0795V13.9749H9.03265V28.8949L13.7936 24.2242ZM25.9976 25.5267L22.0548 21.6454L16.972 26.6187L20.0565 29.6448C20.1504 29.7369 20.2041 29.8553 20.2041 29.9869H25.9976V25.5267ZM18.93 29.9869L14.1557 25.3031L9.39475 29.9869H18.93ZM14.4105 12.9619H26.5207C26.8023 12.9619 27.0437 13.1855 27.0437 13.4618V28.7502L27.6204 28.8949L31.8449 13.4355L15.4565 9.1332L14.4105 12.9619Z"
      fill="#9002CD"
    />
  </svg>
)

export const PaywallModal = ({
  isOpen,
  onClose,
  onDismiss,
  onSelectPackages,
  onSelectPlans,
}) => {
  const dismissInFlightRef = useRef(false)

  const handleDismiss = () => {
    if (dismissInFlightRef.current) {
      return
    }

    if (!onDismiss) {
      onClose()
      return
    }

    dismissInFlightRef.current = true

    try {
      const result = onDismiss()

      if (result && typeof result.then === 'function') {
        result.catch((error) => {
          console.error('Erro ao tratar o fechamento do paywall:', error)
          onClose()
        }).finally(() => {
          dismissInFlightRef.current = false
        })
      } else {
        dismissInFlightRef.current = false
      }
    } catch (error) {
      console.error('Erro ao tratar o fechamento do paywall:', error)
      dismissInFlightRef.current = false
      onClose()
    }
  }

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className={styles.overlay}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={handleDismiss}
        >
          <motion.div
            className={styles.modal}
            initial={{ opacity: 0, scale: 0.94, y: 18 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.94, y: 18 }}
            transition={{ duration: 0.18 }}
            role="dialog"
            aria-modal="true"
            aria-labelledby="paywall-title"
            onClick={(event) => event.stopPropagation()}
          >
            <div className={styles.content}>
              <div className={styles.logo}>
                <XamaLogo width={194} height={49} />
              </div>

              <header className={styles.header}>
                <h2 id="paywall-title" className={styles.title}>
                  Suas Artes Acabaram
                </h2>
                <p className={styles.subtitle}>
                  Mas não se preocupe, escolha como continuar gerando conteúdo
                  para sua(s) campanha(s).
                </p>
              </header>

              <div className={styles.options}>
                <section className={styles.optionCard}>
                  <div className={styles.optionTitleRow}>
                    <span className={styles.iconBox}>
                      <UpgradeIcon />
                    </span>
                    <h3 className={styles.optionTitle}>
                      Faça o Upgrade do seu Plano
                    </h3>
                  </div>
                  <p className={styles.optionDescription}>
                    Aumente seu limite mensal de artes e campanhas.
                    <br />
                    (Recorrente)
                  </p>
                  <button
                    className={styles.primaryButton}
                    type="button"
                    onClick={onSelectPlans}
                  >
                    Conferir Upgrade de Planos
                  </button>
                </section>

                <section className={styles.optionCard}>
                  <div className={styles.optionTitleRow}>
                    <span className={styles.iconBox}>
                      <PackagesIcon />
                    </span>
                    <h3 className={styles.optionTitle}>
                      Comprar Pacotes de Artes
                    </h3>
                  </div>
                  <p className={styles.optionDescription}>
                    Uso imediato para finalizar sua jornada atual, sem
                    mensalidade. (Avulso)
                  </p>
                  <button
                    className={styles.primaryButton}
                    type="button"
                    onClick={onSelectPackages}
                  >
                    Conferir Pacotes Avulsos
                  </button>
                </section>
              </div>
            </div>

            <footer className={styles.footer}>
              <button
                className={styles.footerButton}
                type="button"
                onClick={handleDismiss}
              >
                Continuar sem gerar artes
              </button>
            </footer>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}

export default PaywallModal
